import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {UrbisoftLoginFormComponent} from './components/urbisoft-login-form/urbisoft-login-form.component';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import {ReactiveFormsModule} from '@angular/forms';
import {MatButtonModule} from '@angular/material/button';
import {RouterModule} from '@angular/router';
import {MatCardModule} from '@angular/material/card';
import {MatInputModule} from '@angular/material/input';
import {CoolSocialLoginButtonsModule} from '@angular-cool/social-login-buttons';
import {UrbisoftRegisterFormComponent} from './components/urbisoft-register-form/urbisoft-register-form.component';


@NgModule({
  declarations: [UrbisoftLoginFormComponent, UrbisoftRegisterFormComponent],
  exports: [
    UrbisoftLoginFormComponent, UrbisoftRegisterFormComponent
  ],
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatIconModule,
    ReactiveFormsModule,
    MatButtonModule,
    RouterModule,
    MatCardModule,
    MatInputModule,
    CoolSocialLoginButtonsModule
  ]
})
export class UrbisoftAuthModule {
}
